import { createContext, ReactNode, useContext, useState } from 'react';

export interface ImageContextType {
  itemList: string[];
  setItemList: (args0: string[]) => void;
  selected: string;
  setSelected: (args0: string) => void;
  search: string;
  setSearch: (args0: string) => void;
  imageUrl: string;
  setImageUrl: (args0: string) => void;
  listChanged: string;
  setListChanged: (args0: string) => void;
  emptyFolder: boolean;
  setEmptyFolder: (args0: boolean) => void;
  folder: string;
  setFolder: (args0: string) => void;
  timestamp: string;
  setTimestamp: (args0: string) => void;
  questionImage: string;
  setQuestionImage: (args0: string) => void;
  questionDeleteImage: string;
  setQuestionDeleteImage: (args0: string) => void;
  currentElement: string;
  setCurrentElement: (args0: string) => void;
}

// Context provider component
interface ImageContextProviderProps {
  children: ReactNode;
}

const ImageContext = createContext<ImageContextType | undefined>(undefined);

export const ImageContextProvider = ({
  children,
}: ImageContextProviderProps): JSX.Element => {
  const [itemList, setItemList] = useState<string[]>([]);
  const [selected, setSelected] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [imageUrl, setImageUrl] = useState<string>('');
  const [listChanged, setListChanged] = useState<string>('');
  const [emptyFolder, setEmptyFolder] = useState<boolean>(false);
  const [folder, setFolder] = useState<string>('');
  const [timestamp, setTimestamp] = useState<string>('');
  const [questionImage, setQuestionImage] = useState<string>('');
  const [questionDeleteImage, setQuestionDeleteImage] = useState<string>('');
  const [currentElement, setCurrentElement] = useState<string>('');

  return (
    <ImageContext.Provider
      value={{
        itemList,
        setItemList,
        selected,
        setSelected,
        search,
        setSearch,
        imageUrl,
        setImageUrl,
        listChanged,
        setListChanged,
        emptyFolder,
        setEmptyFolder,
        folder,
        setFolder,
        timestamp,
        setTimestamp,
        questionImage,
        setQuestionImage,
        questionDeleteImage,
        setQuestionDeleteImage,
        currentElement,
        setCurrentElement,
      }}
    >
      {children}
    </ImageContext.Provider>
  );
};

export const useImageContext = (): ImageContextType => {
  const context = useContext(ImageContext);
  if (!context) {
    throw new Error(
      'useImageContext must be used within a ImageContextProvider'
    );
  }
  return context;
};
